import { render, staticRenderFns } from "./spword.vue?vue&type=template&id=969c351e&scoped=true"
import script from "./spword.vue?vue&type=script&lang=js"
export * from "./spword.vue?vue&type=script&lang=js"
import style0 from "./spword.vue?vue&type=style&index=0&id=969c351e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969c351e",
  null
  
)

export default component.exports